import { ScreenAuthEmail } from '@dms/screen'

export default ScreenAuthEmail
